export default __webpack_public_path__ + "static/media/limb_cube.30fca93e.webp";